export default __webpack_public_path__ + "static/media/slider-on-demand-pay.42bbeaa1.png";